/**
 * Created by khanhduong on 5/15/17.
 */
import {create} from 'apisauce';
import Urls from './urls';
import urls from './urls';
import ApiMethod from './apiMethod';
import config from '../libs/webIMConfig';
import * as constants from '../constants/constants';
import * as CONSTANTS from '../constants/constants';
import * as storageHelper from '../functions/storageHelper';
import retry from 'async.retry';
import {getOS, phoneDetect} from "../functions/utils";
import logService from "../services/logService";

const configApp = require('../../app');
const isNative = !configApp || !configApp.isWebApp;

export default class RestClient {
  constructor() {
    this.timeout = 30000;
    this.config = {
      shouldRetry: true,
      noOfRetry: 6,
      retryDelay: 1500, // Change from 3000 to 1500
      // retryRanges: [[100, 199], [401, 401], [429, 429], [500, 599]]
      // retryRanges: [[100, 199], [429, 429], [500, 599]]
      retryRanges: [[100, 199], [429, 429], [500, 599], [408, 408]], // add 408 Request timeout to retryRanges
      chatRetryStatusCodeRanges: [[500, 502], [401, 401]]
    };
    this.TAG = 'RestClient';
    this.headers = {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    this.BASE_URL = Urls.BASE_URL;
    this.isMobileBrowser = null;
    this.storageCachingSupported = storageHelper.storageCachingSupported();
  }


  //TODO: this is temporary and will be removed once we get a way to authenticate with RHP server
  static createTestToken(baseUrl, isAnonymousAccessToken) {
    let token = null;
    if (baseUrl === Urls.BASE_RHPURL || baseUrl === Urls.NEW_BASE_RHPURL || baseUrl === Urls.AUT_RHPURL) {
      //  return 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6InZIOCJ9.eyJzdWIiOjUsImlhdCI6MTU0MzM5MTI0MywiZXhwIjoxNTQzMzkzMDQzLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJob3Rjb3VwbGUiLCJyb2xlcyI6WyJVc2VyIl0sIk1lbWJlcklEIjoyNTkwfQ.jkhAeF5Kx7I7b72sTSH569CbwGPsJJsAB40Om6YK4vE8z7AHJxSqA9Aesw0EtvUwSAk-MNXlnltNJwoJdeQIeS-2uQRHS0YObMdUNmXEY6URvOerhdTUJt9V4aoSsIbNnYXLVtmp2ezaugxnVB26JT2YKqvcv-_g5cDGcKW6GLs'//config.rhpToken;
      if (storageHelper.storageCachingSupported()) {
        token = storageHelper.getKey(constants.SESSIONS.RHP_TOKEN);
        return token ? 'Bearer ' + token : null;

      } else {

        if (config.rhpToken) {
          return config.rhpToken ? 'Bearer ' + config.rhpToken : null;
        } else {
          if (isAnonymousAccessToken) {
            //   console.log('rhpAnonymousToken'+config.rhpAnonymousToken);
            return config.rhpAnonymousToken ? config.rhpAnonymousToken : null;
          }
        }
      }
    } else {
      if (storageHelper.storageCachingSupported()) {
        token = storageHelper.getKey(constants.SESSIONS.MESSENGER_TOKEN);
        return token ? 'Bearer ' + token : null;
      } else {
        return config.token ? 'Bearer ' + config.token : null;
      }
    }
  }

  static generateErrorObj(url, callCount, response) {
    return {
      url: url,
      callCount: callCount,
      message: response.message,
      status: response.status
    };
  }

  static isInRetryRange(httpStatusCode, statusCodesToRetry) {
    let isInRange = false;
    for (const [min, max] of statusCodesToRetry) {
      const status = httpStatusCode;
      if (status >= min && status <= max) {
        isInRange = true;
        break;
      }
    }
    return isInRange;
  }

  osType() {
    if (isNative) {
      return config.DeviceOS;
    } else {
      return getOS();
    }
  }

  deviceType() {

    if (isNative) {
      // PhoneGap Mobile App
      //console.log("AppOrigin is 'mobileApp'");
      return "MobileApp";
    } else {
      if (this.isMobileBrowser === null) {
        this.isMobileBrowser = phoneDetect();
      }
      if (this.isMobileBrowser) {
        // Mobile Browser
        return "Mobile";
      } else {
        return "Desktop";
      }
    }

  }

  checkRHPTokenExpired(res) {
    // console.log(res,url)
    // console.log("checkRHPTokenExpired", res)
    //  if(url === urls.LOG_CONNECTION) return false
    return ((res.status === 401)
      // && res.data && res.data.ResponseStatus
      // && res.data.ResponseStatus.ErrorCode === 'TokenException'
      // && res.data.ResponseStatus.Message === 'Token has expired'
      && this.BASE_URL === Urls.BASE_RHPURL);
  }

  createResponse(res) {
    let response = null;
    if (this.BASE_URL === Urls.BASE_URL) {
      response = responseData.createResponseData(res.data || {});
    } else {
      response = responseData.createRHPResponseData(res);
    }
    return response;
  }

  setBaseUrl(url) {
    this.BASE_URL = url;
    this.setHeaders();
  }

  setHeaders(headers) {
    if (this.BASE_URL === Urls.BASE_RHPURL || this.BASE_URL === Urls.AUT_RHPURL) {
      this.headers.AppOrigin = this.deviceType();
      this.headers.DeviceOS = this.osType();
      if (config.versions) {
        this.headers.Version = config.versions
      }

    }
    if (headers != null) {
      Object.keys(headers).map((key) => {
        this.headers[key] = headers[key];
      });
    }
  }

  setTimeout(timeout) {
    this.timeout = timeout;
  }

  handleRetry(httpMethod, fn, resolve, reject) {
    const options = {
      times: httpMethod === 'POST' ? 1 : this.config.noOfRetry,
      interval: this.config.retryDelay,
    };

    return retry(options, fn.bind(this), (err, result) => {
      if (err) {
        console.log(`ERROR: Retry API Failure - ApiMethod: ${httpMethod} url: ${err.url} after ${err.callCount} calls. Error:`, err.message);
      }
      return resolve(result);
    });
  }

  logErrorAndEndRetry(err, httpMethod, response, callback) {
    console.log("ERROR: ApiMethod.", httpMethod, err.message);
    response.message = err.message;
    callback(null, response);
  }

  checkAndRetry(url, response, callCount, callback) {
    // console.log(url, response, callCount, callback)
    if (url !== urls.LOG_CONNECTION && this.config.shouldRetry
      && (RestClient.isInRetryRange(response.status, this.config.retryRanges)
        || (this.BASE_URL === Urls.BASE_URL && RestClient.isInRetryRange(response.statusCode, this.config.chatRetryStatusCodeRanges)))) {
      callback(RestClient.generateErrorObj(url, callCount, response), response);
    } else {
      callback(null, response);
    }
  }

  refreshRHPToken(baseUrl, url, refreshToken, testUrl, testUrlResponse, callCount, callback, token) {
    //console.log('refresh Token',baseUrl, token, testUrl)

    const headers = {
      // 'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    headers.AppOrigin = this.deviceType();
    headers.DeviceOS = this.osType();
    if (config.versions) {
      headers.Version = config.versions;
    }
    let restClient = create({
      baseURL: baseUrl,
      timeout: this.timeout,
      headers: headers,
    });
    let params = {};
    if (!!refreshToken) {
      params = {
        RefreshToken: refreshToken
      };
      if (!config.rhpRefreshToken) {
        config.rhpRefreshToken = refreshToken;
      }

      return restClient.post(url, params).then(res => {

        // logService.addLog({
        //   message: `handleTokenExpired at url: ${encodeURI(testUrl)}`,
        //   type: constants.LOG_TYPE.DEBUG,
        //   stackTrace: JSON.stringify({
        //     testUrl,
        //     response: testUrlResponse,
        //     callCount,
        //     browserUrl: isNative ? "" : window.location.href,
        //     browserOS: this.deviceType(),
        //     platform: this.osType(),
        //     currentToken: RestClient.createTestToken(Urls.AUT_RHPURL),
        //     version: '1.1',
        //     newToken: res && res.data ? res.data.AccessToken : "",
        //   }),
        //   category: constants.LOG_CATEGORY.TRACKING_REFRESH_TOKEN,
        // });

        if (res.ok) {
          if (res.data) {
            if (this.storageCachingSupported) {
              storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, res.data.AccessToken);
            }
            config.rhpToken = res.data.AccessToken;
          }
          config.gettingRhpToken = false;
          // if (callback) {
          //     callback(RestClient.generateErrorObj(testUrl, callCount, testUrlResponse), testUrlResponse);
          // }
          if (config.failedRequest && config.failedRequest.length > 0) {
            config.failedRequest.forEach((item) => {
              if (item && typeof item === 'function') {
                item();
              }
            })
            config.failedRequest = [];
          }
          return true;
        } else {
          config.gettingRhpToken = false;
          config.stopGettingRhpToken = true;
          // Token really expired
          if (res.data && res.data.ResponseStatus &&
            (res.data.ResponseStatus.ErrorCode === "TokenException"
              || res.data.ResponseStatus.ErrorCode === "NotFound"
              || res.data.ResponseStatus.ErrorCode === 'ArgumentException')
            || res.status === 404) {
            // TODO: debug Log
            let stackTrace = '';
            stackTrace = `
                                  BaseURL ${baseUrl} \n
                                  RefreshToken ${refreshToken} \n
                                  Token ${token} \n
                                  TestUrlResponse ${JSON.stringify(testUrlResponse)} \n
                                  ResponseStatus ${res.data && res.data.ResponseStatus ? JSON.stringify(res.data.ResponseStatus) : null} \n
                                  StatusCode: ${res.status}
                                  duration:${res.duration}`
            // Log Server
            logService.addLog({
              message: `LOGOUT RefreshToken callBackURL: ${testUrl}`,
              type: CONSTANTS.LOG_TYPE.DEBUG,
              stackTrace: stackTrace,
              category: CONSTANTS.LOG_CATEGORY.GLOBAL,
            });
            config.logOut();
            return false;
          }
          // if (callback) callback(null, testUrlResponse);
          //
          if (token) {
            config.rhpToken = token;
          }
          return true
        }
      }).catch((e) => {
        config.gettingRhpToken = false;
        config.stopGettingRhpToken = true;
        if (typeof config.logOut === "function") {
          logService.addLog({
            message: `LOGOUT RefreshToken API ERROR : ${e}`,
            type: CONSTANTS.LOG_TYPE.DEBUG,
            stackTrace: `Empty refresh Token`,
            category: CONSTANTS.LOG_CATEGORY.GLOBAL,
          });
          config.logOut();
        }
        // callback(null, testUrlResponse);
        return false;
      });
    } else {
      config.gettingRhpToken = false;
      config.stopGettingRhpToken = true;
      if (typeof config.logOut === "function") {
        logService.addLog({
          message: `LOGOUT RefreshToken callBackURL: ${testUrl}`,
          type: CONSTANTS.LOG_TYPE.DEBUG,
          stackTrace: `Empty refresh Token`,
          category: CONSTANTS.LOG_CATEGORY.GLOBAL,
        });
        config.logOut();
      }
      callback(null, testUrlResponse);
      return false;
    }
  }

  setAuthorizationHeader(isAnonymous, isCustomHeader, isAnonymousAccessToken) {

    if (!isAnonymous) {
      let token = RestClient.createTestToken(this.BASE_URL, isAnonymousAccessToken);
      if (!isCustomHeader) {
        if (token) {
          this.restClient.setHeader("Authorization", token);
        } else {
          delete this.restClient.deleteHeader("Authorization");
        }
        return;
      }
    } else {
      this.restClient && this.restClient.deleteHeader && delete this.restClient.deleteHeader("Authorization");
      // delete this.restClient?.deleteHeader?.("Authorization");
    }
    this.restClient.setHeader("Content-Type", 'application/json');
  }

  execute(url, method, body, isAnonymous = false, isCustomHeader = false, isAnonymousAccessToken = false, formData = false, customHeader, extraTimeout = undefined) {
    // const platform = this.deviceType();
    // // Only update param platform in base url is BASE_RHPURL
    // const url = this.BASE_URL === Urls.BASE_RHPURL ? `${urlBase}${urlBase.includes("?") ? "&" : "?"}platform=${platform}` : urlBase;
    if (config.isConnected) {
      this.restClient = create({
        baseURL: this.BASE_URL,
        headers: this.headers,
        timeout: extraTimeout || this.timeout
      });

      if (formData) {
        this.restClient.setHeader("Content-Type", 'multipart/form-data');
      } else {
        this.restClient.setHeader("Content-Type", 'application/json');
      }
      if (customHeader) {
        this.restClient.setHeader("AppOrigin", customHeader.typeAppOrigin);
      }

      let response = new responseData();
      // if (!isAnonymous && !config.rhpToken) return new Promise((resolve, reject) => {
      //
      // })
      // console.log(url,this.restClient)
      switch (method) {
        case ApiMethod.GET: {
          return new Promise((resolve, reject) => {
            let callCount = 0;
            const self = this;

            function fn(callback) {
              this.setAuthorizationHeader(isAnonymous, isCustomHeader, isAnonymousAccessToken);

              callCount++;
              this.restClient.get(url, body).then(res => {

                response = this.createResponse(res);
                if (!isAnonymous && this.checkRHPTokenExpired(res)) {
                  this.handleTokenExpired(url, response, callCount, callback);
                } else {
                  this.checkAndRetry(url, response, callCount, callback);
                }
              }).catch(err => {
                this.logErrorAndEndRetry(err, 'GET', response, callback);
              });
            }

            return this.handleRetry('GET', fn, resolve, reject);
          });
        }
        case ApiMethod.POST: {
          return new Promise((resolve, reject) => {
            let callCount = 0;
            const self = this;

            function fn(callback) {
              this.setAuthorizationHeader(isAnonymous, isCustomHeader);
              callCount++;
              this.restClient.post(url, body).then(res => {
                response = this.createResponse(res);
                if (!isAnonymous && this.checkRHPTokenExpired(res)) {
                  this.handleTokenExpired(url, response, callCount, callback);
                } else {
                  this.checkAndRetry(url, response, callCount, callback);
                }
              }).catch(err => {
                // Handle check retry when response timeout of notify message sent API
                if (url && url.includes(urls.NOTIFY_MESSAGE_SENT)) {
                  response.status = 408;
                  this.checkAndRetry(url, response, callCount, callback);
                } else {
                  this.logErrorAndEndRetry(err, 'POST', response, callback);
                }
              });
            }

            return this.handleRetry('POST', fn, resolve, reject);
          });
        }
        case ApiMethod.PUT: {
          return new Promise((resolve, reject) => {
            let callCount = 0;

            function fn(callback) {
              this.setAuthorizationHeader(isAnonymous, isCustomHeader);
              callCount++;
              this.restClient.put(url, body).then(res => {
                response = this.createResponse(res);
                if (!isAnonymous && this.checkRHPTokenExpired(res)) {
                  this.handleTokenExpired(url, response, callCount, callback);
                } else {
                  this.checkAndRetry(url, response, callCount, callback);
                }
              }).catch(err => {
                this.logErrorAndEndRetry(err, 'PUT', response, callback);
              });
            }

            return this.handleRetry('PUT', fn, resolve, reject);
          });
        }
        case ApiMethod.DELETE: {
          return new Promise((resolve, reject) => {
            let callCount = 0;

            function fn(callback) {
              this.setAuthorizationHeader(isAnonymous, isCustomHeader);
              callCount++;
              this.restClient.delete(url, {}, {data: body}).then(res => {
                response = this.createResponse(res);
                if (!isAnonymous && this.checkRHPTokenExpired(res)) {
                  this.handleTokenExpired(url, response, callCount, callback);
                } else {
                  this.checkAndRetry(url, response, callCount, callback);
                }
              }).catch(err => {
                this.logErrorAndEndRetry(err, 'DELETE', response, callback);
              });
            }

            return this.handleRetry('DELETE', fn, resolve, reject);
          });
        }

        case ApiMethod.PATCH: {
          return new Promise((resolve, reject) => {
            let callCount = 0;

            function fn(callback) {
              this.setAuthorizationHeader(isAnonymous, isCustomHeader);
              callCount++;
              this.restClient.patch(url, body).then(res => {
                response = this.createResponse(res);
                if (!isAnonymous && this.checkRHPTokenExpired(res)) {
                  this.handleTokenExpired(url, response, callCount, callback);
                } else {
                  this.checkAndRetry(url, response, callCount, callback);
                }
              }).catch(err => {
                this.logErrorAndEndRetry(err, 'PATCH', response, callback);
              });
            }

            return this.handleRetry('PATCH', fn, resolve, reject);
          });
        }

      }
    } else {
      console.log('NetWork error: Not connected or slow internet');
      return new Promise((resolve, reject) => {
        // if (typeof config.noNetworkEventFirerRef === "function") {
        //   config.noNetworkEventFirerRef();
        // }
        throw 'NetWork error: Not connected or slow internet';
      });
    }

  }

  handleTokenExpired(url, response, callCount, callback) {
    let refreshToken = null;
    if (this.storageCachingSupported) {
      refreshToken = storageHelper.getKey(constants.SESSIONS.RHP_REFRESH_TOKEN);
    } else {
      refreshToken = config.rhpRefreshToken;
    }
    let func = () => callback(RestClient.generateErrorObj(url, callCount, response), response)
    config.failedRequest.push(func)
    // setTimeout(() => {
    //    ;
    // }, this.config.retryDelay * 3);
    if (!config.gettingRhpToken) {
      config.gettingRhpToken = true;
      if (!config.stopGettingRhpToken)

        this.refreshRHPToken(Urls.AUT_RHPURL, Urls.RHP_GET_ACCESSTOKEN, refreshToken, url, response, callCount, callback);
    }
  }
}


class responseData {

  constructor() {
    this.success = false;
    this.statusCode = "";
    this.message = "";
    this.data = null;
    this.status = 0;
  }

  static createResponseData(_data) {
    //console.log(_data)
    let data = new responseData();
    if (_data) {
      data.success = _data.success;
      data.status = _data.status;
      data.statusCode = _data.statusCode || "";
      if (_data.problem && _data.problem === "TIMEOUT_ERROR") {
        data.message = "Request timeout";
      }
      data.message = _data.message || "";
      if (Array.isArray(_data.data)) {
        data.data = {items: _data.data};
      } else {
        data.data = _data.data || null;
      }
    }
    return data;
  }

  static createRHPResponseData(res) {
    // console.log('RHP res',res)
    let data = new responseData();
    data.status = res.status;
    data.success = (!((res.data && res.data.ResponseStatus && res.data.ResponseStatus.ErrorCode)
      || (res.status < 200 || res.status >= 300) || (res.data && (res.data.Success === false)))) || res.ok || res.status === 204;
    if (res.problem) {
      if (res.problem === "TIMEOUT_ERROR") {
        data.message = "Request timeout";
        data.status = 408;
      } else if (res.problem === "NETWORK_ERROR") {
        data.message = "Network error";
        data.status = 408;
      }
      // force assign status to 408 to support function checkAndRetry
    }

    if (res.data) {
      data.statusCode = (res.data.ResponseStatus && res.data.ResponseStatus.ErrorCode) ? res.data.ResponseStatus.ErrorCode : "200";
      data.message = (res.data.ResponseStatus && res.data.ResponseStatus.Message) ? res.data.ResponseStatus.Message : "";

      if (Array.isArray(res.data)) {
        data.data = {items: res.data};
      } else {
        data.data = res.data || null;
      }
    }

    return data;
  }
}

// import Urls from './urls';
// import ApiMethod from './apiMethod';
// import axios from 'axios';
// import webIMConfig from '../libs/webIMConfig';
//
// export default class RestClient {
//
//   constructor() {
//     this.BASE_URL = Urls.BASE_URL;
//   }
//
//   setBaseUrl(url) {
//     this.BASE_URL = url;
//   }
//
//   execute(url, method, body, isAnonymous = false, isCustomHeader = false, isAnonymousAccessToken = false, formData = false, customHeader, extraTimeout = undefined) {
//     let axiosConfig = {baseURL: this.BASE_URL, isAnonymous, isAnonymousAccessToken};
//     if (extraTimeout) {
//       axiosConfig.timeout = extraTimeout;
//     }
//
//     if (webIMConfig.isConnected) {
//       switch (method) {
//         case ApiMethod.GET: {
//           return axios.get(url, axiosConfig);
//         }
//         case ApiMethod.POST: {
//           if (formData) {
//             axiosConfig.headers= {'Content-Type': 'multipart/form-data'};
//           }
//
//           return axios.post(url, body, axiosConfig);
//         }
//         case ApiMethod.PUT: {
//           return axios.put(url, body, axiosConfig);
//         }
//         case ApiMethod.PATCH: {
//           return axios.patch(url, body, axiosConfig);
//         }
//         case ApiMethod.DELETE: {
//           return axios.delete(url, axiosConfig);
//         }
//         default:
//           return new Promise((resolve, reject) => resolve());
//       }
//     }
//     else{
//       console.log('NetWork error: Not connected or slow internet');
//       return new Promise((resolve, reject) => {
//         if (typeof webIMConfig.noNetworkEventFirerRef === "function") {
//           webIMConfig.noNetworkEventFirerRef();
//         }
//         reject('NetWork error: Not connected or slow internet');
//       });
//     }
//   }
// }
